import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const initialState: {
  version: number;
  currentUser: any;
  isFetching: boolean;
  error: boolean;
  userFavorites: any;
} = {
  version: 17,
  currentUser: null,
  isFetching: false,
  error: false,
  userFavorites: null,
};

const userSlice = createSlice({
  name: "user",
  initialState: initialState,
  reducers: {
    loginStart: (state: any) => {
      state.isFetching = true;
    },
    loginSuccess: (state: any, action: any) => {
      state.isFetching = false;
      state.currentUser = action.payload;
      state.error = false;
    },
    loginFailure: (state: any) => {
      state.isFetching = false;
      state.error = true;
    },
    logout: (state: any) => {
      if (state.version !== initialState.version) {
        return initialState;
      }
      localStorage.removeItem("persist:root");
      state.currentUser = null;
      state.userFavorites = null;
    },
    updatePrfile: (state: any, action: any) => {
      const updatedFields = action.payload;

      // Update only the fields that are present in updatedFields
      for (const field in updatedFields) {
        if (field in state.currentUser) {
          state.currentUser[field] = updatedFields[field];
        }
      }
    },
    updateFavorites: (state: any, action: any) => {
      state.userFavorites = action.payload;
    },
    updateUserRole: (state, action: PayloadAction<string>) => {
      if (state.currentUser) {
        state.currentUser.role = action.payload;
      }
    },
  },
});

export const {
  loginStart,
  loginSuccess,
  loginFailure,
  logout,
  updatePrfile,
  updateFavorites,
  updateUserRole,
} = userSlice.actions;
export default userSlice.reducer;
